import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit, OnChanges } from '@angular/core';
import { AlertService } from 'app/services/alert.service';

@Component({
  selector: 'app-square-image-upload',
  templateUrl: './square-image-upload.component.html',
  styleUrls: ['./square-image-upload.component.scss']
})
export class SquareImageUploadComponent implements OnInit, OnChanges {

  @Input() productId?: number;
  @Input() imageUrl?: string;
  @Input() productName?: string = 'Produto';
  @Input() editable: boolean = true;
  @Input() excludable: boolean = true;
  @Input() resetTrigger?: boolean = false; // Trigger para resetar o componente
  
  @Output() imageChanged = new EventEmitter<File | null>();
  
  @ViewChild('fileInput') fileInput!: ElementRef;
  
  previewUrl: string | null = null;
  isDragging: boolean = false;
  private lastResetTrigger?: boolean;
  private hasLocalSelection: boolean = false;

  constructor(private _alertService: AlertService) {}

  ngOnInit() {
    if (this.imageUrl) {
      this.previewUrl = this.imageUrl;
    }
    this.lastResetTrigger = this.resetTrigger;
  }

  ngOnChanges() {
    // Atualiza preview quando imageUrl mudar, mas apenas se não houver seleção local pendente
    if (this.imageUrl && !this.hasLocalSelection) {
      this.previewUrl = this.imageUrl;
    }
    
    // Reset quando resetTrigger mudar de false para true
    if (this.resetTrigger !== this.lastResetTrigger && this.resetTrigger === true) {
      this.reset();
      this.lastResetTrigger = this.resetTrigger;
    }
  }

  reset() {
    this.previewUrl = null;
    this.hasLocalSelection = false;
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.handleFile(input.files[0]);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.handleFile(event.dataTransfer.files[0]);
    }
  }

  handleFile(file: File) {
    if (!this.editable) return;

    // Validar tipo de arquivo
    if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
      this._alertService.error("Formato de imagem não suportado. Somente 'jpg' e 'png' são permitidos.");
      return;
    }

    // Validar tamanho (5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB em bytes
    if (file.size > maxSize) {
      this._alertService.error("Imagem muito grande. O tamanho máximo é 5MB.");
      return;
    }

    // Marcar que há uma seleção local para evitar que ngOnChanges sobrescreva o preview
    this.hasLocalSelection = true;

    // Criar preview
    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewUrl = e.target?.result as string;
    };
    reader.readAsDataURL(file);

    // Emitir evento com o arquivo
    this.imageChanged.emit(file);
  }

  openFileSelector() {
    if (this.editable) {
      this.fileInput.nativeElement.click();
    }
  }

  deleteImage() {
    if (!this.editable) return;
    
    if (confirm("Você tem certeza que quer excluir essa imagem?")) {
      this.previewUrl = null;
      this.hasLocalSelection = false;
      this.fileInput.nativeElement.value = '';
      this.imageChanged.emit(null);
    }
  }

  getInitials(): string {
    if (!this.productName) return 'P';
    return this.productName
      .split(' ')
      .map(word => word[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }
}
